export const ROUTE_SIGN_UP = '/signup/';
export const MY_HUNGRYROOT_ROUTE = '/myhungryroot/';
export const EDIT_DELIVERY_RECIPES_ROUTE = '/edit-delivery/recipes/';
export const EDIT_DELIVERY_GROCERIES_ROUTE = '/edit-delivery/groceries/';
export const PLAN_ROUTE = '/plan/';
export const LOGIN_ROUTE = '/login/';
export const WALLET_ROUTE = '/wallet/';

export const CYO_ROUTE = '/limited-time/';
export const CHECKOUT_CONGRATS_ROUTE = '/checkout/congrats/';
export const CHECKOUT_SHIPPING_ROUTE = '/checkout/shipping/';
export const CHECKOUT_V2_SHIPPING_ROUTE = '/checkout/shipping-v2/';
export const CHECKOUT_V2_PAYMENT_ROUTE = '/checkout/payment-v2/';
export const CHECKOUT_PAYMENT_ROUTE = '/checkout/payment/';
export const REACTIVATE_ROUTE = '/account/reactivated/';
export const ORDER_ROUTE = '/order/';
export const ORDER_DETAILS_ROUTE = '/order/:orderId/';
export const SUPPORT_ARTICLE_ROUTE = '/support-articles/';
export const SUPPORT_ARTICLE_QUICK_TOUR_ROUTE = '/support-articles/quick-tour/';
export const SUPPORT_ARTICLE_SHOP_WITH_CREDITS_ROUTE =
  '/support-articles/shop-with-credits/';
export const SUPPORT_ARTICLE_FIRST_DELIVERY_ROUTE =
  '/support-articles/first-delivery/';
export const SUPPORT_ARTICLE_FOOD_PROFILE_ROUTE =
  '/support-articles/food-profile/';
export const SUPPORT_ARTICLE_SCHEDULE_MANAGEMENT_ROUTE =
  '/support-articles/schedule-management/';
export const SUPPORT_ARTICLE_DELIVERY_ISSUES_ROUTE =
  '/support-articles/delivery-issues/';
export const SUPPORT_ARTICLE_EDIT_ORDER_ROUTE = '/support-articles/edit-order/';
export const SUPPORT_ARTICLE_EDIT_PLAN_ROUTE = '/support-articles/edit-plan/';

export const ACCOUNT_HISTORY_ROUTE = '/account/history/';
export const ACCOUNT_SETTINGS_ROUTE = '/account/settings/';
export const ACCOUNT_PREFERENCES_ROUTE = '/preferences/';
export const ACCOUNT_HELP_CENTER_ROUTE = '/faq/';
export const ACCOUNT_ORDER_HISTORY_ROUTE = '/account/history/';
export const ACCOUNT_REFERRAL_ROUTE = '/account/referral/';

// Experiment 192; Scannable entry points
export const BROWSE_GROCERIES_ROUTE = '/browse/groceries/';
export const BROWSE_RECIPES_ROUTE = '/browse/recipes/';

export const GIFT_ROUTE = '/gift/';
export const COMMUNITY_URL = 'https://www.facebook.com/groups/hungryroot';
export const EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE =
  '/edit-delivery/recipes/for-you/';
export const EDIT_DELIVERY_GROCERIES_FOR_YOU_ROUTE =
  '/edit-delivery/groceries/for-you/';

export const CA_EMPLOYEE_PRIVACY_POLICY_ROUTE = '/privacy/ca-employee-notice/';
export const UPCOMING_ORDERS_ROUTE = '/upcoming';

export const WELCOME_ROUTE = '/welcome/';
export const ATTRIBUTION_SURVEY_ROUTE = '/attribution-survey/';
export const PROTEIN_PREFERENCES_ROUTE = '/protein-preferences/';
export const SAUCE_PREFERENCES_ROUTE = '/sauce-preferences/';
export const FOOD_PROFILE_ROUTE = '/food-profile/';
export const FOOD_PROFILE_IMPROVE_SMARTCART_ROUTE =
  '/food-profile/improve-my-smartcart/';
export const FOOD_PROFILE_DIETARY_PREFERENCES_ROUTE =
  '/food-profile/dietary-preferences/';
export const FOOD_PROFILE_NEVERS_ROUTE = '/food-profile/nevers/';

export const CANCEL_FIRST_ORDER_ROUTE = '/cancel/first-order/';
export const CANCEL_BENEFITS_ROUTE = '/cancel/benefits/';

export { isEqualPathnames } from './isEqualPathnames';
export { isEqualToAtLeastOnePathname } from './isEqualToAtLeastOnePathname';

export const PRECHECKOUT_PLAN_ROUTE = '/survey/plan/';

export const generateDynamicAccountOrdersRoute = ({
  orderId,
}: {
  orderId: number | string;
}) => `/account/orders/${orderId}/`;

export const generateOrderDetailRoute = ({
  orderId,
}: {
  orderId: number | string;
}) => `/order/${orderId}/`;

// Quiz routes
export const ROUTE_QUIZ_INTRO = '/quiz/intro/';
export const ROUTE_QUIZ_BUDGET = '/quiz/budget/';
export const ROUTE_QUIZ_BUDGET_BENEFITS = '/quiz/budget-benefits/';
export const ROUTE_QUIZ_HELLO = '/quiz/hello/';
export const ROUTE_QUIZ_GOALS = '/quiz/hello/goals/';
export const ROUTE_QUIZ_GOALS_BENEFITS = '/quiz/goals-benefits/';
export const ROUTE_QUIZ_EATING_HABITS = '/quiz/eating-habits/';
export const ROUTE_QUIZ_EATING_HABITS_DIETARY_NEEDS =
  '/quiz/eating-habits/dietary-needs/';
export const ROUTE_QUIZ_MACRO_NUTRIENT = '/quiz/macro-nutrient/';
export const ROUTE_QUIZ_MACRO_NUTRIENT_LOW_SODIUM =
  '/quiz/macro-nutrient/low-sodium/';
export const ROUTE_QUIZ_FOOD_QUALITIES = '/quiz/food-qualities/';
export const ROUTE_QUIZ_FOOD_FORMATS = '/quiz/food-formats/';
export const ROUTE_QUIZ_CUISINES = '/quiz/cuisines/';
export const ROUTE_QUIZ_FLAVORS = '/quiz/flavors/';
export const ROUTE_QUIZ_MEAT = '/quiz/meat/';
export const ROUTE_QUIZ_SEAFOOD = '/quiz/seafood/';
export const ROUTE_QUIZ_PLANTS = '/quiz/plants/';
export const ROUTE_QUIZ_POLARIZING = '/quiz/polarizing/';
export const ROUTE_QUIZ_FOOD_PREFERENCES_INTRO =
  '/quiz/food-preferences-intro/';
export const ROUTE_QUIZ_BREAKFAST = '/quiz/breakfast/';
export const ROUTE_QUIZ_BREAKFAST_FREQUENCY = '/quiz/breakfast/frequency/';
export const ROUTE_QUIZ_READY_MADE = '/quiz/ready-made/';
export const ROUTE_QUIZ_SNACKS = '/quiz/snacks/';
export const ROUTE_QUIZ_SNACKS_FREQUENCY = '/quiz/snacks/frequency/';
export const ROUTE_QUIZ_SWEETS = '/quiz/sweets/';
export const ROUTE_QUIZ_SWEETS_FREQUENCY = '/quiz/sweets/frequency/';
export const ROUTE_QUIZ_LUNCH = '/quiz/lunch/';
export const ROUTE_QUIZ_LUNCH_FREQUENCY = '/quiz/lunch/frequency/';
export const ROUTE_QUIZ_DINNER = '/quiz/dinner/';
export const ROUTE_QUIZ_DINNER_FREQUENCY = '/quiz/dinner/frequency/';
export const ROUTE_QUIZ_BUILDING = '/quiz/building/';
export const ROUTE_QUIZ_DISH_TYPES = '/quiz/dish-types/';
